/* ========================================================================
 * FD:          FD
 * Child:       SITE
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * handle top navigation popovers
 * https://github.com/sandywalker/webui-popover
 * ======================================================================== 
 * 12/18/2015: creation
 * 4/10/16: reworked for new CSS
 * 6/29/2016: innosuite 2016 rework
*/

FD.SITE = (function ($, me) {
    'use strict';

    var child = me.SITE || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    var POPOVER_ELEM = '[data-site-popover="true"]';            //  all the top popover buttons                                                     //  all the valid popovers to handle
    var SEARCHINPUT_ELEM = '#SITE_SEARCH';                      //  used to trap the search box for special click/hover events
    var SEARCHINPUT_NOHASH_ELEM = 'SITE_SEARCH';

    var list = [];

    var defaults = {
        popoverid: '',
        height: 300,
        width: 200
    };

    var current = {
        show: false,
        id: '',
        target: '',
        poptarget: '',
        isinput: false
    };



    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  set top popover
    function setTopPopovers() {
        var popList = $(POPOVER_ELEM);

        if (popList.length === 0) return;

        popList.each(function () {
            var elem = $(this);

            //  set options
            var options = $.extend({}, defaults, elem.data());
            options.element = elem;
            options.elementhash = '#' + elem[0].id;
            options.elementid = elem[0].id;

            //  set data
            elem.data(options);

            //  add to array
            list.push(elem);
        });

        for (var x = 0, len = list.length; x < len; x++) {
            setPopover(list[x]);
        }

        //  set document events
        setDocumentEvents();
    }


    //  set popover
    function setPopover(e) {
        var data = e.data();

        //  options
        var options = {
            type: 'html',
            url: data.popoverid,
            placement: 'bottom-right',  //auto-bottom
            animation: 'pop',
            closeable: true,
            multi: false,
            style: 'inverse',
            offsetTop: (data.popoverid === '#POP_SEARCH') ? -3 : -8,
            trigger: 'manual',
            container: '.site-top-navigation'
        };

        e.webuiPopover('destroy').webuiPopover(options)
            .on('show.webui.popover', function (elem, pop) {
                var e = $(this);
                current.poptarget = $(pop).get(0).id;
                current.isinput = (e.get(0).tagName.toLowerCase() == 'input') ? true : false;
                current.show = true;
            })
            .on('shown.webui.popover', function (elem, pop) {                
                var scrollContainer = $("#SITE_APP_LIST").closest('[data-fd="scroll"]');
                var currentLocatoin = window.location.pathname;
                elem = $("#SITE_APP_LIST").find('a[href*="' + currentLocatoin + '"]');               
                if (elem && elem.length > 0 && elem.first().offset()) {
                    scrollContainer.slimScroll({ scrollBy: (elem.first().offset().top - $("#SITE_APP_LIST").offset().top) + 'px' });
                }               
            })
            .on('hide.webui.popover', function (elem, pop) {
                current.poptarget = '';
                current.isinput = false;
                current.show = false;

                $(SEARCHINPUT_ELEM).removeClass('in');
            });

        //  set event
        setPopoverEvent(e);
    }


    //  set popover event
    function setPopoverEvent(e) {
        var data = e.data();
        var NAMESPACE = me.getUID('POP_');
        var DELAY = 200;


        function showPopover(e) {
            setTimeout(function () {
                e.webuiPopover('show');
            }, DELAY);
        }


        function attemptOpen() {
            var e = $(this);

            e.addClass('in');

            //  nothing open
            if (!current.show) {
                setGlobal(e);
                showPopover(e);
                return;
            }

            //  open but not me 
            //  close first
            if (current.show && e.data().elementhash !== current.id) {
                hideAllButMe(e);
                setGlobal(e);
                showPopover(e);
                return;
            }
        }


        // set element click
        $(document).on('click.sitep' + NAMESPACE, data.elementhash, attemptOpen);


        //  set site search input
        if (data.elementhash === SEARCHINPUT_ELEM) {
            $(document).on('input.searchinput' + NAMESPACE, data.elementhash, setSiteSearch);
        }

        $('.site-search-tab').off().on('click', function (event) {
            var elem = $(this);
            if (!elem.is('a')) {
                elem = elem.parent();
            }

            var data = elem.data();
            if (!elem.data('loaded')) {
                $(elem.attr('href')).find('div > div > div').html('<div class="wp-100 text-center"><i class="fa fa-fw fa-spinner fa-spin"></i></div>');
                // the tab index, since it's zero-based, is 1 off from the search type enum
            }

            me.SITE.getTabSearchResults($(this).parent().index() + 1, elem);
        })
    }





    /* ========================================================================
     *  global methods
     * ========================================================================
    */
    //  hide all but me
    function hideAllButMe(e) {
        var data = e.data();
        for (var x = 0, len = list.length; x < len; x++) {
            var d = list[x];
            if (d[0].id == data.elementid) continue;
            d.webuiPopover('hide');
        }
    }


    //  set global popover
    function setGlobal(e) {
        current.id = e.data().elementhash;
        current.target = e.data().popoverid;
    }


    //  set document events
    function setDocumentEvents() {

        //  hide all
        function hideAll() {
            for (var x = 0, len = list.length; x < len; x++) {
                var d = list[x];
                d.webuiPopover('hide');
            }
        }


        //  click
        function clickPop(event) {
            //  not in show
            if (!current.show) return;

            var target = $(event.target);
            var input_target = target[0].id;

            //  target off popover but in input box
            if (target.parents('div#' + current.poptarget).length === 0 && (input_target !== SEARCHINPUT_NOHASH_ELEM)) {
                hideAll();
            }
        }


        //  key
        function keyPop(event) {
            //  not in show
            if (!current.show) return;

            //  esc
            if (event.which == 27 || event.keyCode == 27) {

                var active = $(document.activeElement)[0].id || '_';        //  added for chrome bug

                //  if not focus in input
                hideAll();
            }

            //  enter in search box
            if (event.which == 13 || event.keyCode == 13) {
                if (current.id === SEARCHINPUT_NOHASH_ELEM) getSearchResults();
            }

        }


        // Hide all on manual resize but not $().resize for redraws.
        function resize(e) {
            if (e.originalEvent) {
                hideAll();
            }
        }


        $(document).on('click.sitepxxx', clickPop);
        $(document).on('keyup.sitepxxx', keyPop);        //  kill if out of bounds

        $(window).on('resize.sitepxxx', resize);  //  kill on resize site
    }


    //  set site search
    function setSiteSearch() {
        if (this.delay) clearTimeout(this.delay);
        this.delay = setTimeout(function () {
            getSearchResults();
        }, 850);
    }


    //  get search
    function getSearchResults() {
        me.SITE.getSiteSearchResults();
    }








    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set top navigation popovers
    child.setTopPopovers = function () {
        setTopPopovers();
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));